import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, Input, Cascader, AutoComplete, Select, message, Tabs, Checkbox, Pagination, Spin } from 'antd'
import FilePreview from '../../../FilePreview'
import * as API from '../../../../../api'
import * as UTILS from '../../../../../utils'
import { InboxOutlined } from '@ant-design/icons'
import { getAllCity, getTcityHome } from '../../../../../utils/global'
import './index.less'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
const { Option } = Select
const { TabPane } = Tabs

const areEqual = (prevProps, nextProps) => {
	return prevProps.url === nextProps.url
}
const ShowImg = React.memo((props) => {
	const random = Math.random()
	const frameid = 'frameimg' + random
	window[`img_${random}`] = '<img id="img" width="100%" src=\'' + props.url.split('?')[0] + '?' + random + '\' /><script>window.onload = function() { parent.document.getElementById(\'' + frameid + '\').height = \'80px\'; }<' + '/script>'
	const iframe= `<iframe id="${frameid}" src="javascript:parent['img_${random}'];" frameBorder="0" scrolling="no" width="100%" height="100%"></iframe>`
	return <div className="material-item-main"  dangerouslySetInnerHTML={{__html: iframe}}></div>
},areEqual)

const LeadBusiness = ({
	leadBusinessProps
}) => {
	const onFinish = () => {

	}
	const handleCancel = () => {
		leadBusinessProps.handleLeadBusiness(false)
	}
	interface SearchValue {
		type?: number;
		id?: string;
	}
	interface SearchInputProps {
		value?: SearchValue;
		onChange?: (value: SearchValue) => void;
	}
	const [materialData, setMaterialData] = useState({text_list: [], image_list: [], video_list: []})
	const [imageList, setImageList] = useState([])
	const [videoList, setVideoList] = useState([])
	const [textList, setTextList] = useState([])

	const [previewInfo, setPreviewInfo] = useState({content: '', type: '图片'})
	const [previewVisible, setPreviewVisible] = useState(false)

	const [queryBody, setQueryBody] = useState({page_size: 20, page_no: 1})
	const [pageTotal, setPageTotal] = useState(0)

	const [type, setType] = useState(1)
	const [sug, setSug] = useState('')
	const [dataType, setDataType] = useState('image')

	const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
	const [spinning, setSpinning] = useState(false)
	const [imageCheckAll, setImageCheckAll] = useState(false)
	const [videoCheckAll, setVideoCheckAll] = useState(false)
	const [textCheckAll, setTextCheckAll] = useState(false)
	const [isNoMore, setIsNoMore] = useState(false)

	const [allCity, setAllCity] = useState([])
	const [sid, setSid] = useState(0) // 景点id
	const [cityId, setcityId] = useState(0) // 景区和民宿=》城市id
	const [allCityId, setallCityId]=useState('')
	const [hotelId, setHotelId] = useState(0) // 酒店商品库=》酒店id
	const [options, setOptions] = useState<SelectProps<object>['options']>([])
	// 业务类型变化
	const onChangeType = async (newType: React.SetStateAction<number>) => {
		setMaterialData({text_list: [], image_list: [], video_list: []})
		console.log('newType',newType)
		setType(newType)
		setcityId(0)
		setHotelId(0)
		setSid(0)
		setSug('')
		setallCityId('')
		if(newType === 2) {
			const city = await getAllCity()
			setAllCity(city)
			// console.log('景区', city)
		} else if(newType === 6) {
			const city = await getTcityHome()
			// console.log('todo 民宿', city)
			city.forEach(item => {
				if(!item.id) {
					item.id = Math.random()
				}
			})
			setAllCity(city)
		}
	}

	// 获取除酒店的其他业务数据
	const getOtherBusiness = async () => {
		setMaterialData({text_list: [], image_list: [], video_list: []})
		setSpinning(true)
		const params = Object.assign({}, queryBody, {type, data_type: dataType})
		if(type === 5) {
			params.sug = sug
		}
		if(type === 2) {
			params.sid = sid
		}
		const { code, data, msg } =  await API.getBusiness(params)
		setSpinning(false)
		const newMaterialData = {text_list: [], image_list: [], video_list: []}
		if(code === 0 && data) {
			const haveData = data[dataType] && JSON.stringify(data[dataType]) !== '{}'
			if(haveData) {
				if((type === 3 || type == 4) && !data[dataType].errcode) {
					data[dataType].item.map((item: { url: any; content: { news_item: any[] } }, index: number) => {
						const itemIndex = (index+1)+(queryBody.page_size*(queryBody.page_no-1))
						if(dataType == 'image') {
							newMaterialData.image_list.push(`${item.url}&index=${itemIndex}`)
						} else if (dataType === 'video') {
							newMaterialData.video_list.push(`${item.url}&index=${itemIndex}`)
						} else {
							item.content.news_item.map((news: { content: any }) => {
								newMaterialData.text_list.push(news.content)
							})
						}
					})
				} else {
					if(dataType === 'image') {
						if(data[dataType].length === 0) {
							setIsNoMore(true)
						} else if(isNoMore){
							setIsNoMore(false)
						}
						const dataList = data[dataType]
						dataList.forEach((item, index) => {
							dataList[index] = `${item}&random=${Math.random()}`
						})
						newMaterialData.image_list = dataList
					}
				}
				console.log(newMaterialData)
				setPageTotal(data[dataType].total_count)
				setMaterialData(newMaterialData)
			} else {
				//暂无数据
				setPageTotal(0)
			}
		} else {
			// message.error(msg ? msg : '暂无数据')
			setPageTotal(0)
			setMaterialData({text_list: [], image_list: [], video_list: []})
		}
	}


	// 知识产权input变化
	const onChangeKnowledge = (val) => {
		setSug(val.currentTarget.value)
	}
	// 获取酒店联想搜索
	const getHotelList = async (searchText) => {
		const { code, data, msg } = await API.getHotelList({type, sug: searchText})
		const searchResult = []
		if(code === 0) {
			data.forEach((item: { name: any; id: any }) => {
				searchResult.push({value: item.name, key: item.id})
			})
			return searchResult
		} else {
			message.error(msg)
			return searchResult
		}
	}
	// 获取景区联想搜索
	const getSearchList = async (searchText) => {
		const { code, data, msg } = await API.getSearchList({type, cityID: cityId, sug: searchText})
		const searchResult = []
		if(code == 0 && data) {
			data.forEach((item: {name: string; id: string}) => {
				searchResult.push({value: item.name, key: item.id})
			})
			return searchResult
		} else {
			// message.error(msg ? msg : '暂无数据')
			return searchResult
		}
	}
	const searchResult = (searchText: string) => {
		if(type === 1) {
			return getHotelList(searchText)
		} else if(type === 2 || type === 6) {
			return getSearchList(searchText)
		}
	}

	const handleSearchAotoComplete = async (value: string) => {
		const result = await searchResult(value)
		setOptions(value ? result : [])
	}
	const autoCompleteSelect = async (value: string, options: object) => {
		console.log(options)
		setSpinning(true)
		let params = {}
		if(type === 1) {
			params = {
				type,
				id: options?.key ? options?.key : hotelId
			}
			options?.key && setHotelId(options.key)
		} else if(type === 2) {
			params = {
				type,
				sid: options?.key ? options.key : sid
			}
			options?.key && setSid(options.key)
		}
		const { code, data, msg } =  await API.getBusiness(params)
		setSpinning(false)
		if(code === 0 && data && JSON.stringify(data) !== '{}') {
			const key = Object.keys(data)[0]
			data[key].forEach((item, index) => {
				if(item.indexOf('?') > -1) {
					data[key][index] = `${item}&random=${Math.random()}`
				} else {
					data[key][index] = `${item}?random=${Math.random()}`
				}
			})
			setMaterialData(data)
		} else {
			// message.error(msg)
			setMaterialData({text_list: [], image_list: [], video_list: []})
		}
	}
	const handleSearch = () => {
		// console.log('114',type, dataType, 'sid',sid,'sug:',sug,'cityId',cityId)
		setMaterialData({text_list: [], image_list: [], video_list: []})
		if(type === 1 && hotelId !== 0) autoCompleteSelect('', {})
		if(type === 5 && sug !== '') getOtherBusiness()
		if((type === 2 || type === 6) && cityId !== 0 && sid !== 0) getOtherBusiness()
		if(type === 3 || type === 4) getOtherBusiness()
	}
	useEffect(() => {
		handleSearch()
	}, [queryBody, type, dataType])
	// 提交选择的素材
	const handleSubmit = async () => {
		const submitValue = []
		imageList.map(item => {
			submitValue.push({
				st_fileurl: item,
				type: '图片'
			})
		})
		videoList.map(item => {
			submitValue.push({
				st_fileurl: item,
				type: '视频'
			})
		})
		textList.map(item => {
			submitValue.push({
				st_text_content: item,
				type: '文章'
			})
		})
		// 如果链接不是项目域名, 需要上传
		try {
			const replaceUrl = async (item: { st_fileurl: any }, i: number) => {
				const { st_fileurl: url } = item
				if (url && !url.includes('file.40017.cn') && !url.includes('cdc-qa.elong.com')) {
					const params = { fileurl: url }
					if (url.includes('mmbiz.qpic.cn')) { // 公众号
						params.st_format = UTILS.getUrlParams(url).wx_fmt
					}
					if(
						url.indexOf('.JPG') === -1 &&
						url.indexOf('.PNG') === -1 &&
						url.indexOf('.jpg') === -1 &&
						url.indexOf('.png') === -1
					) {
						if(item.type === '图片') params.st_format = 'jpg'
					}
					const { code, data, msg } = await API.addFileForUrl(params)
					if (code === 0) {
						submitValue[i].st_fileurl = data
					} else {
						message.error(msg)
					}
				}
			}
			const promises = submitValue.map((item, i) => replaceUrl(item, i))
			setConfirmLoading(true)
			await Promise.all(promises)
			setConfirmLoading(false)
		} catch (error) {
			setConfirmLoading(false)
		}
		leadBusinessProps.handleLeadBusinessData(submitValue)
		leadBusinessProps.handleLeadBusiness(false)
		setImageList([])
		setVideoList([])
		setTextList([])
		setMaterialData({text_list: [], image_list: [], video_list: []})
	}

	// 选择或取消选择素材
	const onCheckMaterial = (type: string, value: any) => {
		if(type === '图片') {
			setImageCheckAll(false)
			const newImageList = [...imageList]
			newImageList.includes(value) ? newImageList.remove(value) : newImageList.push(value)
			setImageList(newImageList)
		} else if (type === '视频') {
			setVideoCheckAll(false)
			const newVideoList = [...videoList]
			newVideoList.includes(value) ? newVideoList.remove(value) : newVideoList.push(value)
			setVideoList(newVideoList)
		} else if(type === '文字') {
			setTextCheckAll(false)
			const newTextlist = [...textList]
			newTextlist.includes(value) ? newTextlist.remove(value) : newTextlist.push(value)
			setTextList(newTextlist)
		}
	}
	// 无数据
	const noDataNode = () => {
		return (
			<Spin size="large" spinning={spinning}>
				<div className="no-data-wrap">
					<p><InboxOutlined/></p>
					<p>请选择业务线并搜索相关内容</p>
				</div>
			</Spin>
		)
	}
	// 预览参数及显示
	const  handlePreview = (info: React.SetStateAction<{ content: string; type: string }>) => {
		setPreviewInfo(info)
		setPreviewVisible(true)
	}
	// 预览 关闭
	const handlePreviewVisible = (val: React.SetStateAction<boolean>) => {
		setPreviewVisible(val)
	}
	// 城市选择
	const changeCitySelect = (val) => {
		console.log('changeCitySelect',val)
		setallCityId(val)
		setcityId(val[val.length -1])
	}
	//全选
	const checkAll = (event: CheckboxChangeEvent,type: string) => {
		const checked= event.target.checked
		if(type === '图片') {
			let newImageList = []
			setImageCheckAll(checked)
			if(checked) {
				newImageList = [...materialData.image_list]
			} else {
				newImageList = imageList.filter(item => {
					if(!materialData.image_list.includes(item)) {
						return item
					}
				})
			}
			setImageList(newImageList)
		} else if (type === '视频') {
			setVideoCheckAll(checked)
			let newVideoList = []
			if(checked) {
				newVideoList = [...materialData.video_list]
			} else {
				newVideoList = imageList.filter(item => {
					if(!materialData.video_list.includes(item)) {
						return item
					}
				})
			}
			setVideoList(newVideoList)
		} else if(type === '文字') {
			setTextCheckAll(checked)
			let newTextlist = []
			if(checked) {
				newTextlist = [...materialData.text_list]
			} else {
				newTextlist = imageList.filter(item => {
					if(!materialData.text_list.includes(item)) {
						return item
					}
				})
			}
			setTextList(newTextlist)
		}
	}
	// 切换当前页数
	const changeCurrentPage = (val: string) => {
		setImageCheckAll(false)
		setVideoCheckAll(false)
		setTextCheckAll(false)
		setQueryBody({page_no: val, page_size: 20})
	}
	// 分页每页数量改变
	const changePageSize = (val: any,size: number) => {
		setImageCheckAll(false)
		setVideoCheckAll(false)
		setTextCheckAll(false)
		const query = Object.assign({},queryBody)
		query.page_size = size
		setQueryBody(query)
	}
	// 知识产权上一步、下一步
	const changePrevNext =(type) => {
		const query = Object.assign({},queryBody)
		const pageNo = parseFloat(query.page_no)
		query.page_no = type === 'prev' ? pageNo - 1 : pageNo + 1
		setQueryBody(query)
	}
	// tab切换图片/视频/文字
	const changeTabpane = (val: React.SetStateAction<string>) => {
		setDataType(val)
		if(type !== 1) {
			setQueryBody({page_no: 1, page_size: 20})
		}
	}
	const [form] = Form.useForm()
	useEffect(() => {
		form.setFieldsValue({type, id: '', sug: '', allCityId: ''})
	},[type])
	return (
		<Modal
			forceRender
			visible={leadBusinessProps.leadBusinessVisible}
			title="业务数据"
			onOk={handleSubmit}
			onCancel={handleCancel}
			confirmLoading={confirmLoading}
			className={type !== 1 ? 'for-padding' : ''}
			centered
		>
			<Form
				form={form}
				className="lead-business-form"
				name="customized_form_controls"
				layout="inline"
				onFinish={onFinish}
				initialValues={{
					search: {
						type: 1,
						id: '',
					},
				}}
			>
				<Form.Item name="type" rules={[{ required: true, message: '请选择业务线' }]}>
					<Select
						value={type}
						style={{ width: type === 1 || type === 5 || type === 2  || type === 6? 152 : 200, margin: '0 17px 0 4px' }}
						onChange={onChangeType}
					>
						<Option value={1}>酒店商品库</Option>
						<Option value={6}>民宿商品库</Option>
						<Option value={2}>景区商品库</Option>
						<Option value={5}>知识产权数据库</Option>
						<Option value={3}>同程艺龙旅行公众号</Option>
						<Option value={4}>同程艺龙研发中心公众号</Option>
					</Select>
				</Form.Item>
				{
					(type === 2 || type === 6) &&
					<Form.Item>
						<Cascader
							style={{ width: 393, margin: '0 0 0 4px' }}
							options={allCity}
							value={allCityId}
							fieldNames={{label: 'label', value: 'id', children: 'children'}}
							onChange={changeCitySelect}
							expandTrigger='hover'
							placeholder="请选择地区"
						/>
					</Form.Item>
				}
				{(type === 1 || type === 2 || type === 6) &&
					<Form.Item name="id" rules={[{ required: true, message: '请输入关键字' }]}>
						<AutoComplete
							className="lead-business-auto"
							dropdownMatchSelectWidth={type === 1 ? 315 : 488}
							style={{ width: type === 1 ? 315 : 488, margin: '0 17px 0 0' }}
							options={options}
							onSelect={autoCompleteSelect}
							onSearch={handleSearchAotoComplete}
							placeholder="请输入关键字"
						>
						</AutoComplete>
					</Form.Item>
				}
				{
					type === 5 &&
					<Form.Item name="sug" rules={[{ required: true, message: '请输入关键字' }]}>
						<Input value={sug} onChange={onChangeKnowledge} placeholder="请输入关键字" style={{ width: 311, margin: '0 17px 0 4px' }} />
					</Form.Item>
				}
				<Form.Item>
					<Button type="primary" htmlType="submit" onClick={handleSearch}>
						搜索
					</Button>
				</Form.Item>
			</Form>
			<div className="material-list-wrap">
				<Tabs defaultActiveKey={dataType} onChange={changeTabpane}>
					{leadBusinessProps.businessList.includes('图片') &&
						<TabPane tab="图片" key="image">
							<div className="material-list clearfix">
								{
									materialData.image_list && materialData.image_list.length > 0 ?
										materialData.image_list.map((item, index) => {
											return (
												<div className="material-item" key={index}>
													{type !== 3 && type !== 4 ?
														<img src={item} alt="图片" onClick={() => handlePreview({content: item, type: '图片'})}/>
														:
														<ShowImg url={item}/>
													}
													{type !== 1 && <div className="frame-shade" onClick={() => handlePreview({content: item, type: '图片'})}></div>}
													<div className={ imageList.includes(item) ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox'} onClick={() => onCheckMaterial('图片', item)}>
														<span className="ant-checkbox-inner"></span>
													</div>
												</div>
											)
										})
										: noDataNode()
								}
							</div>
							<div className="material-calculate">已选择: {imageList.length}张图片、{videoList.length}个视频{leadBusinessProps.businessList.includes('文字') && `、${textList.length}段文字`}<Checkbox checked={imageCheckAll} onChange={(e) => checkAll(e,'图片')}>全选</Checkbox></div>
						</TabPane>
					}
					{leadBusinessProps.businessList.includes('视频') && type !== 5 &&
						<TabPane tab="视频" key="video">
							<div className="material-list clearfix">
								{
									materialData.video_list && materialData.video_list.length > 0 ?
										materialData.video_list.map((item, index) => {
											return (
												<div className="material-item" key={index}>
													{/* <div>{JSON.stringify(item)}</div> */}
													{/* <img src="//m.elongstatic.com/cdc/com-static/video.png" alt="视频"/> */}
													{item.includes('.mp4') ?
														<video src={item} onClick={() => handlePreview({content: item, type: '视频'})}></video>
														:
														<img src="//m.elongstatic.com/cdc/com-static/video.png" onClick={() => handlePreview({content: item, type: '视频'})} alt="视频"/>
													}
													<div className={ videoList.includes(item) ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox'}  onClick={() => onCheckMaterial('视频', item)}>
														<span className="ant-checkbox-inner"></span>
													</div>
												</div>
											)
										})
										: noDataNode()
								}
							</div>
							<div className="material-calculate">已选择: {imageList.length}张图片、{videoList.length}个视频{leadBusinessProps.businessList.includes('文字') && `、${textList.length}段文字`}  <Checkbox checked={videoCheckAll} onChange={(e) => checkAll(e,'视频')}>全选</Checkbox></div>
						</TabPane>
					}
					{leadBusinessProps.businessList.includes('文字') && type !== 5 &&
						<TabPane tab="文字" key="text">
							<div className="material-text-list">
								{
									materialData.text_list && materialData.text_list.length > 0 ?
										materialData.text_list.map((item, index) => {
											return (
												<div className="material-text-item" key={index}>
													<div className={ textList.includes(item) ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox'} onClick={() => onCheckMaterial('文字', item)}>
														<span className="ant-checkbox-inner"></span>
													</div>
													<div dangerouslySetInnerHTML={{__html: item}}></div>
												</div>
											)
										})
										: noDataNode()
								}
							</div>
							<div className="material-calculate">已选择: {imageList.length}张图片、{videoList.length}个视频、{textList.length}段文字  <Checkbox checked={textCheckAll} onChange={(e) => checkAll(e,'文字')}>全选</Checkbox></div>
						</TabPane>
					}
				</Tabs>
				{
					(type === 3 || type === 4) && pageTotal > 0 && <div className="pagination-wrap">
						<Pagination
							onChange={changeCurrentPage}
							defaultPageSize={queryBody['page_size']}
							current={queryBody['page_no']}
							onShowSizeChange={changePageSize}
							// showSizeChanger={false}
							total={pageTotal}
						/>
					</div>
				}
				{
					type === 5 && <div className="pagination-wrap">
						<Button className="prev" onClick={() => changePrevNext('prev')} disabled={queryBody['page_no'] == 1 ? true : false}>上一页</Button>
						<Button className="next" onClick={() =>changePrevNext('next')} disabled={isNoMore}>下一页</Button>
					</div>
				}
			</div>
			{/* 预览 */}
			<FilePreview
				{...previewInfo}
				visible={previewVisible}
				handleVisible={handlePreviewVisible}
			/>
		</Modal>
	)
}
export default LeadBusiness